import { createQueryKeys } from "@lukemorales/query-key-factory";
import { GetClientRequest, GetClientsRequest } from "@/Stub/V1";

export const Clients = createQueryKeys('clients', {
    detail: (requestParams: GetClientRequest) => [{ requestParams }],
    list: (requestParams?: GetClientsRequest) => [{ requestParams }],
});